<div class="row mt-3">
  <hr />
  <div class="col">© {{ year }} - daylight AG</div>
  <div class="col">Department: {{ displayname | async }}</div>
  <div class="col text-end">WebApi v{{ webApiVersion | async }}</div>
  <div class="col text-end">Letzter CRM Import: {{ lastImport | async }}</div>
  <div class="col text-end">Praxistool v{{ version }}</div>
</div>
